<template>
  <div class="HeaderBar">
    <div class="top-bar-left" @click="goToRouter('/')">
      <img :src="`${$CdnServerAddress}websit/web/logo.png`" />
    </div>
    <div class="top-bar-middle">
      <div
        :class="[
          'menu-item',
          { actived: activeIndex == menuIndex },
          { 'has-select': menuItem.hasSelect },
        ]"
        v-for="(menuItem, menuIndex) in menuList"
        :key="menuIndex"
        @click="selectMenu(menuItem, menuIndex, 1)"
      >
        {{ menuItem.name }}

        <div class="select-icon" v-if="menuItem.hasSelect">
          <img :src="`${$CdnServerAddress}websit/web/icon-select.svg`" />
        </div>

        <div class="select-container" v-if="menuItem.children">
          <div class="select-connect"></div>
          <div class="select-box">
            <div
              class="select-option"
              v-for="(childrenItem, childrenIndex) in menuItem.children"
              :key="childrenIndex"
            >
              <div
                v-for="(selectItem, selectIndex) in childrenItem"
                :key="selectIndex"
              >
                <a :href="selectItem.path" :style="selectItem.style">{{
                  selectItem.name
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-bar-right">
      <div class="right-contact">
        <img :src="`${$CdnServerAddress}websit/web/phone.svg`" />
        400-105-1798
      </div>
      <div class="right-apply" @click="openApplyDialog">
        申请试用
        <img :src="`${$CdnServerAddress}websit/web/more1.svg`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderBar",
  data() {
    return {
      activeIndex: -1,
      menuList: [
        {
          id: 1,
          name: "首页",
          path: "/",
          hasSelect: false,
        },
        {
          id: 2,
          name: "产品中心",
          hasSelect: true,
          children: [
            [{ name: "亿话", path: "/yihua" }],
            [{ name: "亿影", path: "/yiying" }],
            // [{ name: "亿播", path: "/yibo" }],
            [{ name: "交互一体机", path: "/jiaohu" }],
          ],
        },
        {
          id: 3,
          name: "解决方案",
          hasSelect: true,
          children: [
            [
              { name: "数字文旅", path: "/tourism" },
              { name: "智能终端", path: "/model" },
            ],
            [
              { name: "广电融媒", path: "/television" },
              { name: "定制服务", path: "/customize" },
            ],
            [
              { name: "展览展示", path: "/exhibition" },
              { name: "其他行业", path: "/other" },
            ],
            [{ name: "数字教师", path: "/teacher" }],
          ],
        },
        {
          id: 4,
          name: "代理合作",
          path: "/cooperation",
          hasSelect: false,
        },
        {
          id: 5,
          name: "关于我们",
          hasSelect: true,
          children: [
            [
              {
                name: "公司介绍",
                path: "/introduction#nd1Nne2R8QDSsDxB",
              },
            ],
            [
              {
                name: "开发者平台",
                path: "/introduction#9cJKdZf2i56B4nnt",
              },
            ],
            [{ name: "荣誉资质", path: "/introduction#HBhG1ebcN4BxTZA4" }],
            [{ name: "客户案例", path: "/introduction#TNAAJKa7i0cPPwwD" }],
            // [
            //   {
            //     name: "公司介绍",
            //     path: "/introduction#nd1Nne2R8QDSsDxB",
            //     style:
            //       "width: 5.375rem;text-align: left;padding-left: 0.625rem",
            //   },
            //   { name: "加入我们", path: "/introduction#8SF8HYa1tAHaN7C2" },
            // ],
            // [
            //   {
            //     name: "公司大事记",
            //     path: "/introduction#B7SFAfEH5nE6sapN",
            //     style:
            //       "width: 5.375rem;text-align: left;padding-left: 0.625rem",
            //   },
            //   { name: "荣誉资质", path: "/introduction#HBhG1ebcN4BxTZA4" },
            // ],
            // [
            //   {
            //     name: "开发者平台",
            //     path: "/introduction#9cJKdZf2i56B4nnt",
            //     style:
            //       "width: 5.375rem;text-align: left;padding-left: 0.625rem",
            //   },
            //   { name: "客户案例", path: "/introduction#TNAAJKa7i0cPPwwD" },
            // ],
            // [
            //   {
            //     name: "资讯动态",
            //     path: "/introduction#0WMQpe9Ga1D6B8ss",
            //     style:
            //       "width: 5.375rem;text-align: left;padding-left: 0.625rem",
            //   },
            // ],
          ],
        },
      ],
    };
  },
  mounted() {
    this.menuList.forEach((menuItem, menuIndex) => {
      if (menuItem?.path && menuItem.path == location.pathname) {
        this.activeIndex = menuIndex;
        return;
      }
      if (this.activeIndex == -1 && menuItem?.children) {
        menuItem?.children.forEach((cItem) => {
          cItem.forEach((item) => {
            if (item.path.indexOf(location.pathname) != -1) {
              this.activeIndex = menuIndex;
              return;
            }
          });
        });
      }
    });
  },
  methods: {
    goToRouter(path) {
      location.href = path;
    },
    selectMenu(item, index, type) {
      if (type == 1 && item.hasSelect) return;
      this.activeIndex = index;
      this.goToRouter(item.path);
    },
    openApplyDialog() {
      window.open("https://yh.bdbdigital.com", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.HeaderBar {
  width: calc(~"100% - 120px");
  padding: 0 60px;
  background: #000105;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .top-bar-left {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 148px;
      margin: 17px 0;
    }
  }

  .top-bar-middle {
    width: 40%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .menu-item {
      float: left;
      font-size: 16px;
      line-height: 32px;
      padding: 15px 0;
      min-width: 96px;
      text-align: center;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      position: relative;
      margin-right: 10px;

      &.has-select {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &.actived,
      &:hover {
        border-color: #a6000d;
      }

      &:hover {
        .select-icon {
          transform: rotate(90deg);
        }

        .select-container {
          display: block;
        }
      }

      .select-icon {
        width: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: rotate(0deg);
        transition: all 0.3s;

        img {
          width: 100%;
        }
      }

      .select-container {
        display: none;
        position: absolute;
        top: 64px;
        left: 0;

        .select-connect {
          height: 4px;
        }

        .select-box {
          background: #000000;
          border-radius: 4px;

          .select-option {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            div {
              a {
                width: 96px;
                line-height: 40px;
                text-align: center;
                color: #8c8c8c;
                text-decoration: none;
                display: block;

                &:hover {
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  .top-bar-right {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .right-contact {
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      margin-right: 60px;

      img {
        width: 25px;
        margin-right: 8px;
        animation: shake-rotate 3s ease-in-out infinite;
      }

      @keyframes shake-rotate {
        89% {
          transform: translate(0) rotate(0deg);
        }
        90% {
          transform: translate(0) rotate(15deg);
        }
        91% {
          transform: translate(0) rotate(0deg);
        }
        92% {
          transform: translate(0) rotate(-15deg);
        }
        93% {
          transform: translate(0) rotate(0deg);
        }
        94% {
          transform: translate(0) rotate(15deg);
        }
        95% {
          transform: translate(0) rotate(0deg);
        }
        96% {
          transform: translate(0) rotate(-15deg);
        }
        97% {
          transform: translate(0) rotate(0deg);
        }
        98% {
          transform: translate(0) rotate(15deg);
        }
        99% {
          transform: translate(0) rotate(-15deg);
        }
        0%,
        100% {
          transform: translate(0) rotate(0);
        }
      }
    }

    .right-apply {
      padding: 8px 24px;
      background: #a6000d;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;

      &:hover {
        background: #80000f;
      }

      img {
        width: 16px;
        margin-left: 8px;
      }
    }
  }
}
</style>